export default __webpack_public_path__ + "c0e13f8ae8e0df6b2651372618f06207.svg";